<br />
<div class="row">
  <div class="col-md-6">
    <h4>Revenue Codes</h4>
  </div>
  <div class="col-md-6">
    <h4>Selected</h4>
  </div>
</div>

<div class="row">
  <div class="col-md-6">
    <app-grid-wrapper #available (cellDoubleClicked)="select()">
      <div class="row">
        <div class="col-xs-9">
          <button
            type="button"
            class="btn btn-default"
            [disabled]="availableSelection.length === 0"
            (click)="select()"
          >
            <i class="fa fa-arrow-right"></i> Add To Selected
          </button>
        </div>
      </div>
    </app-grid-wrapper>
  </div>

  <div class="col-md-6">
    <app-grid-wrapper #selected (cellValueChanged)="fieldChanged($event)">
      <button
        type="button"
        class="btn btn-default"
        [disabled]="selectedSelection.length === 0"
        (click)="remove()"
      >
        <i class="fa fa-arrow-left"></i> Remove from Selected
      </button>
      <button type="button" class="btn btn-default" (click)="importClicked()">Import</button>
    </app-grid-wrapper>
  </div>
</div>
